import useSWR from "swr";
import API from "../../../utils/api";
import { INDEXPIRCE } from "../../constants/TRADEAPIKEYS";
import { useToken } from "../auth/token";
import throttle from 'lodash/throttle';
import { isEqual } from 'lodash';
import { useMultiTickerStore } from "../MultiTickerStore";
import { useExchangeStore } from "./exchangeStore";
import { useMultiAggStore } from "../MultiAggStore";

let swrData: any = [];
let getAPI = true

let lastcall: any = null

export function useIndexPrice(ep: number) {
	const { data: token, getLatestToken } = useToken()
	const KEY: any = INDEXPIRCE + '?ep_id=' + 0

	const {EPs} = useExchangeStore()
	  const { tickers } = useMultiAggStore();
	

	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			if (!getAPI) return swrData || []
			const currentToken = getLatestToken()
			const response = await API.get(KEY, currentToken + '', {}, false)
			swrData = response?.result || [];

			setTimeout(() => {
				getAPI = false
			}, 100)

			return swrData || []
		},
		{
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
		}
	)

	const list =
		(data &&
			data?.length >= 0 &&
			data?.find((item: any) => item?.ep_id == ep)?.result) ||
		[]

  const throttledMutate = throttle(
    (value?: any, epid?: number) => {
      mutate((prev: any) => {
        if (!Array.isArray(prev)) prev = [];

        const prevItem = prev.find((item: any) => item?.ep_id === epid);
        const isSame = isEqual(prevItem?.result, value);

        if (isSame) return prev;

        const updated = prevItem
          ? prev.map((item: any) =>
            item.ep_id === epid ? { ep_id: epid, result: { ...value } } : item
          )
          : [...prev, { ep_id: epid, result: { ...value } }];

        swrData = updated;
        return updated;
      });
    },
    200,  // ✅ 300ms → 200ms (실시간성 개선)
    { trailing: true, leading: true }  // ✅ leading: true 추가 (즉시 실행)
  );

	return {
		data: list,
		reset: where => {
			console.log('reset where', where)

			const now = new Date().getTime()
			if (lastcall != null && now - lastcall < 10000) {
				return
			}
			lastcall = now
			getAPI = true
			mutate()
		},
    mutate: throttledMutate,
		// mutate: (value?: any, epid?: number) => {
		// 	try {
		// 		return mutate((prev: any) => {
    //
		// 			if (!Array.isArray(prev)) {
		// 				console.log('prev', prev)
    //
		// 				prev = [];
		// 			}
    //
    //       const catchItem = prev.find((item: any) => item?.ep_id == epid);
    //       if (
    //         catchItem &&
    //         JSON.stringify(catchItem.result) === JSON.stringify(value)
    //       ) {
    //         return prev;
    //       }
    //
    //       const updated = catchItem
    //         ? prev.map((item: any) =>
    //           item.ep_id === epid
    //             ? { ep_id: epid, result: { ...value } }
    //             : item
    //         )
    //         : [...prev, { ep_id: epid, result: { ...value } }];
    //
    //       swrData = updated;
    //       return updated;
    //
		// 			// if (prev?.find((item: any) => item?.ep_id == epid)) {
		// 			// 	const temp = prev?.map((item: any) => {
		// 			// 		if (item?.ep_id == epid) {
		// 			// 			return {
		// 			// 				ep_id: epid,
		// 			// 				result: { ...value },
		// 			// 			}
		// 			// 		} else {
		// 			// 			return item
		// 			// 		}
		// 			// 	})
		// 			// 	swrData = temp
		// 			// 	return temp
		// 			// } else {
		// 			// 	swrData = [
		// 			// 		...prev,
		// 			// 		{
		// 			// 			ep_id: epid,
		// 			// 			result: { ...value },
		// 			// 		},
		// 			// 	]
		// 			// 	return swrData
		// 			// }
		// 		})
		// 	} catch (e) {
		// 		return mutate()
		// 	}
		// },
		getPrice: (epid?: number) => {
			try {
				const E = EPs?.find((item: any) => item?.id == (epid || ep))

				const symbol = E?.pairs?.replace('/', '').toLowerCase();

				const price = tickers[symbol].price || 0;

				return price;
			} catch (e) {
				return 0;
			}
		},
		getPriceAll: (epid?: number) => {
			try {
				return (
					data?.find((item: any) => item?.ep_id == (epid || ep))
						?.result
				)
			} catch (e) {
				return 0
			}
		},
	}
}
